import { FC } from 'react'
import { useLocation } from 'react-router-dom'
import { Typography } from '@material-tailwind/react'

interface FaqParagraphProps {
  title: string
  text: string
  id: string
}

const FaqParagraph: FC<FaqParagraphProps> = ({ title, text, id }) => {
  const { hash } = useLocation()

  const textColor = hash === `#${id}` ? 'text-accent' : 'dark:text-white'

  return (
    <div id={id} className="mb-6 self-start text-left">
      <Typography variant="h3" className={textColor}>
        {title}
      </Typography>
      <Typography variant="paragraph" className={textColor}>
        {text}
      </Typography>
      <hr className="w-full mt-6 opacity-20 border-primary dark:border-white" />
    </div>
  )
}

export default FaqParagraph
